export default {
  items: [
    {
      title: true,
      name: 'Admin Area',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Users',
      url: '/admin/users',
      icon: 'icon-user',
    },
    {
      name: 'All Projects',
      url: '/admin/projects/all',
      icon: 'icon-speedometer',
    },
    {
      name: 'Packages',
      url: '/admin/packages',
      icon: 'icon-basket'
    },
    {
      name: 'Invoices',
      url: '/admin/invoices',
      icon: 'icon-folder',
    },
    {
      name: 'Discounts',
      url: '/admin/discounts',
      icon: 'icon-star',
    },
    {
      name: 'Limits',
      url: '/admin/limits',
      icon: 'icon-credit-card',
    }
  ]
}
